var currentVersionFromPackageJson = '0.1.136';
var log = function () {
    /**
     * logo Color Code
     * 31: Red
     * 32: Green
     * 33: Yellow
     * 34: Blue
     * 35: Magenta
     * 36: Cyan
     * 37: White
     */
    var logo = "\u001B[36m\u2588\u2588\u2588\u2557   \u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2588\u2588\u2588\u2557  \u2588\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2557   \u2588\u2588\u2557\u2588\u2588\u2557\n\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2551\n\u2588\u2588\u2554\u2588\u2588\u2588\u2588\u2554\u2588\u2588\u2551\u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2551\u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2551\n\u2588\u2588\u2551\u255A\u2588\u2588\u2554\u255D\u2588\u2588\u2551\u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2551\u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2551\n\u2588\u2588\u2551 \u255A\u2550\u255D \u2588\u2588\u2551\u255A\u2588\u2588\u2588\u2588\u2588\u2588\u2554\u255D\u2588\u2588\u2551  \u2588\u2588\u2551\u255A\u2588\u2588\u2588\u2588\u2588\u2588\u2554\u255D\u2588\u2588\u2551\n\u255A\u2550\u255D     \u255A\u2550\u255D \u255A\u2550\u2550\u2550\u2550\u2550\u255D \u255A\u2550\u255D  \u255A\u2550\u255D \u255A\u2550\u2550\u2550\u2550\u2550\u255D \u255A\u2550\u255D\u001B[0m";
    var title = "moaui (React UI Library) v".concat(currentVersionFromPackageJson);
    var deploy = "- deploy: https://www.npmjs.com/package/@midasit-dev/moaui";
    var repository = "- repository: https://github.com/midasit-dev/moaui";
    var doumentation = "- documentation: https://midasit-dev.github.io/moaui";
    console.log("\n\n\n".concat(logo, "\n\n").concat(title, "\n").concat(deploy, "\n").concat(repository, "\n").concat(doumentation, "\n\n\n"));
};
var Component = function () {
    log();
    return null;
};
var Signature = {
    log: log,
    Component: Component,
};
export default Signature;
